export const USER_STATUS_ACTIVE = 'ACTIVE'
export const USER_STATUS_INACTIVE = 'INACTIVE'

export const USER_STATUSES = [USER_STATUS_INACTIVE, USER_STATUS_ACTIVE]
